import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { REGEX, SELECT_CUSTOM_STYLES } from "constants/CommonConstants";
import { useLocation, useNavigate } from "react-router-dom";
import { GENDER_OPTIONS } from "components/constant";

export const staticUsersList = [
  {
    id: 1,
    name: "Rahul Patil",
    email: "rahul.patil@gmail.com",
    mobile: "9876543210",
    dob: "1998-05-12",
    gender: "Male",
    address: "Pune, Maharashtra",
    status: "ACTIVE",
  },
  {
    id: 2,
    name: "Amit Deshmukh",
    email: "amit.d@gmail.com",
    mobile: "9123456780",
    dob: "1996-09-21",
    gender: "Male",
    address: "Nashik, Maharashtra",
    status: "INACTIVE",
  },
];

const initialFields = {
  firstName: {
    value: "",
    error: "",
  },
  lastName: {
    value: "",
    error: "",
  },
  email: {
    value: "",
    error: "",
  },
  mobile: {
    value: "",
    error: "",
  },
  dob: {
    value: "",
    error: "",
  },
  gender: {
    value: "",
    error: "",
  },
  address: {
    value: "",
    error: "",
  },
  status: {
    value: "ACTIVE",
    error: "",
  },
};

function AddAdmin() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || "add";
  const [formData, setFormData] = useState(initialFields);

  // Prefill form when in edit mode
  useEffect(() => {
    if (mode === "edit") {
      // Always use the first instructor's data from static data
      const userData = staticUsersList[0];

      setFormData({
        firstName: {
          value: userData.name?.split(" ")[0] || "",
          error: "",
        },
        lastName: {
          value: userData.name?.split(" ")[1] || "",
          error: "",
        },
        email: {
          value: userData.email || "",
          error: "",
        },
        mobile: {
          value: userData.mobile || "",
          error: "",
        },
        dob: {
          value: userData.dob || "",
          error: "",
        },
        gender: {
          value:
            GENDER_OPTIONS.find((opt) => opt.value === userData.gender) || null,
          error: "",
        },
        address: {
          value: userData.address || "",
          error: "",
        },
        status: {
          value: userData.status || "ACTIVE",
          error: "",
        },
      });
    }
  }, [mode]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: { value, error: "" },
    }));
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    switch (name) {
      case "firstName":
        return !trimmedValue
          ? "Please enter first name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(value)
            ? "First name must contain only letters and spaces"
            : "";

      case "lastName":
        return !trimmedValue
          ? "Please enter last name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(value)
            ? "Last name must contain only letters and spaces"
            : "";

      case "email":
        return !trimmedValue
          ? "Please enter email"
          : !REGEX.EMAIL_REGEX.test(value)
            ? "Please enter a valid email"
            : "";

      case "mobile":
        return !value
          ? "Please enter mobile number"
          : value.length !== 10
            ? "Mobile number must be 10 digits"
            : !REGEX.PHONE_NO_REGEX.test(value)
              ? "Mobile number must contain only digits"
              : "";

      default:
        return "";
    }
  };

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const validateForm = () => {
    let newAdmin = { ...formData };

    //get all the keys in array
    Object.keys(newAdmin).forEach((key) => {
      newAdmin[key] = {
        ...newAdmin[key],
        error: getValidationError(key, newAdmin[key].value),
      };
    });
    setFormData(newAdmin); //if error set error state
    return Object.values(newAdmin).every((item) => item.error === "");
  };

  const handleSave = () => {
    // if (!validateForm()) return;
    navigate(
      role === "SUPER_ADMIN"
        ? "/super-admin/list"
        : "/admin/list",
    );
  };

  const handleOnCancel = () => {
    setFormData(initialFields);
    navigate(
      role === "SUPER_ADMIN"
        ? "/super-admin/list"
        : "/admin/list",
    );
  };
  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col>
            <Card>
              <CardHeader className="d-flex align-items-center">
                <i
                  className="fa fa-chevron-left mr-2 cursor"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/list"
                        : "/admin/list",
                    )
                  }
                />
                <h3 className="mb-0">
                  {mode === "edit" ? "Edit Admin" : "Add Admin"}
                </h3>
              </CardHeader>

              <CardBody>
                <Form>
                  <Row>
                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">First Name</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="firstName"
                          placeholder="Enter first name"
                          value={formData.firstName.value}
                          onChange={(e) =>
                            handleInputChange("firstName", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.firstName.error ? "is-invalid" : ""
                          }
                        />
                        {formData.firstName.error && (
                          <div className="invalid-feedback d-block">
                            {formData.firstName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Last Name</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Enter last name"
                          value={formData.lastName.value}
                          onChange={(e) =>
                            handleInputChange("lastName", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.lastName.error ? "is-invalid" : ""
                          }
                        />
                        {formData.lastName.error && (
                          <div className="invalid-feedback d-block">
                            {formData.lastName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Email</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email.value}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.email.error ? "is-invalid" : ""}
                        />
                        {formData.email.error && (
                          <div className="invalid-feedback d-block">
                            {formData.email.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Mobile Number
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="tel"
                          name="mobile"
                          placeholder="Enter mobile number"
                          value={formData.mobile.value}
                          onChange={(e) =>
                            handleInputChange("mobile", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.mobile.error ? "is-invalid" : ""}
                          maxLength="10"
                        />
                        {formData.mobile.error && (
                          <div className="invalid-feedback d-block">
                            {formData.mobile.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Status <span className="text-danger">*</span>
                        </Label>

                        <div className="d-flex mt-2">
                          <FormGroup check className="mr-4">
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={formData.status.value === "ACTIVE"}
                                onChange={() =>
                                  handleInputChange("status", "ACTIVE")
                                }
                              />
                              Active
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={formData.status.value === "INACTIVE"}
                                onChange={() =>
                                  handleInputChange("status", "INACTIVE")
                                }
                              />
                              Inactive
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col className="text-right">
                      <Button
                        color="secondary"
                        className="mr-2 px-4 py-2"
                        type="button"
                        onClick={handleOnCancel}
                      >
                        Cancel
                      </Button>

                      <Button
                        color="primary"
                        className="btn-deep-blue mr-2 px-4 py-2"
                        type="submit"
                        onClick={() => {
                          handleSave();
                        }}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AddAdmin;
